import { create } from 'zustand';

export type PaywallVariant = 'upgrade' | 'exhausted' | 'trial' | 'cancelled_trial' | 'exhausted_trial';

interface PaywallState {
  isModalOpen: boolean;
  triggerSource: string | null;
  paywallVariant: PaywallVariant | null;
  isCanvasLocked: boolean;
  canvasDismissed: boolean;
}

interface PaywallActions {
  openPaywall: (source: string, variant?: PaywallVariant) => void;
  closePaywall: () => void;
  setCanvasLocked: (locked: boolean) => void;
  dismissCanvasCenter: () => void;
  resetCanvasDismissed: () => void;
}

export const usePaywallStore = create<PaywallState & PaywallActions>((set) => ({
  isModalOpen: false,
  triggerSource: null,
  paywallVariant: null,
  isCanvasLocked: false,
  canvasDismissed: false,

  openPaywall: (source, variant = 'upgrade') => {
    set({ isModalOpen: true, triggerSource: source, paywallVariant: variant });
  },

  closePaywall: () => {
    set({ isModalOpen: false, triggerSource: null, paywallVariant: null });
  },

  setCanvasLocked: (locked) => {
    set({ isCanvasLocked: locked });
  },

  dismissCanvasCenter: () => {
    set({ canvasDismissed: true });
  },

  resetCanvasDismissed: () => {
    set({ canvasDismissed: false });
  },
}));
